// The Wi-Fi + Bluetooth HUB (ESP32BLEGATEWAY, DeviceID 103 — docs/20) is
// infrastructure, not a control: it carries commands to Bluetooth lamps (and
// later locks, switches, sensors). It is never drawn as a device tile on the
// user screens — room lists, Common devices, Favourites, scene pickers.
//
// ⚠️ ONLY THE USER SCREENS. The admin tools (Device Admin, User Access, MQTT
// console, Device Tracking, firmware) use the SAME list functions and must keep
// seeing it — that is where it is set up, updated and checked. So the filter is
// applied at the user-facing call sites, never inside api.js.
//
// Some lists carry no DeviceID (the location list names the type instead), so
// the type name counts too.

export const HUB_DEVICE_ID = 103;
const HUB_TYPE_NAME = /BLEGATEWAY/i;

export function isHubDevice(row) {
  if (!row) return false;
  if (Number(row.DeviceID ?? row.DeviceId) === HUB_DEVICE_ID) return true;
  return HUB_TYPE_NAME.test(String(row.DeviceTypeName || ''));
}

/** A list, or a `{ data: [...] }` reply, without hubs. Anything else passes through. */
export function withoutHubs(res) {
  if (Array.isArray(res)) return res.filter((r) => !isHubDevice(r));
  if (res && Array.isArray(res.data)) return { ...res, data: res.data.filter((r) => !isHubDevice(r)) };
  return res;
}
